// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Sj-V","type":"styles_type__1SZeh","choices":"styles_choices__1acMw"};